(function () {
    'use strict';

    angular
        .module('app.saveAsCustomReport')
        .factory('saveAsCustomReportService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function saveAsCustomReport(params, loader) {
                    var url_saveAsCustomReport = $rootScope.apiUrl + 'measure/saveAsCustomReport';
                    return handleRequest(url_saveAsCustomReport, 'POST', params, loader);
                }

                service.saveAsCustomReport = saveAsCustomReport;

                return service;
            }
        ]);
})();
